<template>
  <div>
    <h1 class="title is-3 table-padding-fix">Laatste {{logs.length}} logs</h1>
    <div class="columns">
      <div class="column is-8">
        <table class="table is-striped">
          <thead>
            <tr>
              <th>Level</th>
              <th>Bericht</th>
              <th>Datum</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="log in logs">
              <td>{{log.type}}</td>
              <td>{{log.message}}</td>
              <td>{{log.createdAt | timezone | date}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="column">
        <div class="content notification is-primary has-white-text spacing-top-40">
          <h2>System Logs</h2>
          <p>System logs worden hier niet getoond. Deze logs worden op de server opgeslagen en zijn te vinden op de gedocumenteerde locatie.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      logs: 'userLogs'
    })
  },
  async created () {
    try {
      await this.$store.dispatch('getUserLogs')
    } catch (error) {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens het ophalen van de systeem logs.'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/logs.vue